import script from "./OrdinaryClassPeopleAdder.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrdinaryClassPeopleAdder.vue?vue&type=script&setup=true&lang=ts"

import "./OrdinaryClassPeopleAdder.vue?vue&type=style&index=0&id=0897a376&lang=css"

const __exports__ = script;

export default __exports__